//@flow
import { TextField } from '@material-ui/core';
import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateCart, RemoveFromCart } from 'src/actions';
import { useHistory,useParams  } from "react-router-dom";
import styled, { ThemeProvider } from 'styled-components';
import { themeWithRtl } from 'src/theme';
import './cart.scss'
import {
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core';
import Payment from './Payment';

const Cart = (props) => {
  const cart = useSelector((state) => state.session.cart);
  const card = useSelector((state) => state.session.card);

  const history = useHistory();
  const { slug } = useParams()
  const dispatch = useDispatch();
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    vh: () => 0,
    vw: () => 0,
  });

  const { backgroundImage, backgroundImageBottom, avatar, font, textColor, logo, designTemplate, couponImage } = props;
  const containerRef = useRef();
  const catalog = () => {
    history.push(`/${slug}`);
  }

  const sendToWhatsapp = () => {
    const whatsappShare = `
שלום ברצוני לרכוש את הפרטים הבאים
    %0a
${cart.map((itemCart) => {
      let numb = itemCart.item.price.match(/\d/g);
      numb = numb.join("");
      const price = Number.parseInt(numb) 
      const details =  `שם הפריט - ${itemCart.item.title}, כמות ${itemCart.count} , מחיר ${price} ש"ח`
      return details
    }).join("%0a")}
    %0a
סה"כ לתשלום:${cart.reduce((total, itemCart) => {
      let numb = itemCart.item.price.match(/\d/g);
      numb = numb.join("");
      const price = Number.parseInt(numb) 
      return total + (price * itemCart.count)
      }, 0)} ש"ח 
    `
    window.open(`https://wa.me/${card.phoneNumber}?text=${whatsappShare}`);
  }
  useEffect(() => {
    if(!card.isSalePage){
      catalog()
    }
  }, [card])

  useEffect(() => {
    if (containerRef) {
      const width = containerRef.current.clientWidth;
      const height = containerRef.current.clientHeight;
      setDimensions({
        width,
        height,
        vh: (y) => (height / 100) * y,
        vw: (x) => (width / 100) * x,
      });
    }
  }, [containerRef]);
  const cardTheme = createMuiTheme({
    ...themeWithRtl,

    typography: {
      allVariants: {
        color: textColor,
      },
      fontFamily: font,
      fontSize: 16,
      htmlFontSize: 16,
      color: textColor,
      h1: { fontSize: '1.75rem' },
      h2: { fontSize: '1.5rem' },
      h3: { fontSize: '1.25rem' },
      h4: { fontSize: '1rem' },
      h5: { fontSize: '0.75rem' },
    },
  });
  return (
    <ThemeProvider
      theme={{
        ...props,
        'font-family': 'roboto' || props.font,
        dimensions,
      }}
    >
      <div
        ref={containerRef}
        style={{
          maxWidth: '100vw',
          flexGrow: 1,
          fontFamily: '"Arial",sans-serif',
          overflowX: 'hidden',
          backgroundColor: 'white',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          fontSize: 18
        }}
      >
        <MuiThemeProvider theme={cardTheme}>
          <div className='go-back' onClick={catalog}>{`< חזרה לקטלוג`}</div>
          <div style={{ marginTop: '20px' }}>אנו שמחים שבחרת לרכוש אצלנו</div>
          {cart.length ? cart.map((cartItem, index) => (
            <div class="card" style={{
              borderBottom: index !== cart.length - 1 ? 'solid black 1px' : null,
              paddingBottom: index !== cart.length - 1 ? '20px' : null,
            }}>
              <div className='cross' onClick={() => dispatch(RemoveFromCart(cartItem.item))}>
                <img style={{ width: 15, height: 15 }} src="/images/close.png"></img>
              </div>
              <div class="card-image">
                <img src={cartItem.item.image} alt="" />
                <div class="card-name">{cartItem.item.title}</div>
              </div>
              <div class="card-details">
                <div class="card-name">{cartItem.item.description}</div>
                <div className='card-price-container'>
                  <div class="card-price">{cartItem.item.price}</div>
                  <div class="card-wheel">
                    <button onClick={() => dispatch(updateCart(cartItem.item, cartItem.count - 1 < 1 ? 1 : cartItem.count - 1))}>-</button>
                    <span>{cartItem.count}</span>
                    <button onClick={() => dispatch(updateCart(cartItem.item, cartItem.count + 1))}>+</button>
                  </div>
                </div>
              </div>
            </div>)) : null}
          <td>סה"כ לתשלום:{cart.reduce((total, itemCart) => {
            let numb = itemCart.item.price.match(/\d/g);
            numb = numb.join("");
            const price = Number.parseInt(numb) 
            return total + (price * itemCart.count)
            }, 0)} ש"ח</td>
          <button disabled={!cart.length} className='go-to-payment'  onClick={() => sendToWhatsapp()}>שלח לבית העסק</button>
        </MuiThemeProvider>
      </div>
    </ThemeProvider>
  )
}

const CartItem = styled.div`
    display: flex;
    flex-direction: row;
    width: 45%;
    margin-top: 20px;
`;

const CartTitleImage = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    font-size: 18px;
    position: relative;
    align-items: center;
`;

const CartImage = styled.img`
    width: 5rem;
    height 5rem;
`;

const CartDescription = styled.div`
    display: flex;
    flex-direction: column;
    fontSize: 18px;
    position: relative;
    width: ${(div) => div.theme.dimensions.vw(40)}px;
    margin-right: 15px;
    justify-content: center;
`;

const CartPriceAndCount = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 18px;
    position: relative;
    align-items: center;
`;

const LightboxPrice = styled.div`
  background-color: #111111;
  margin: 0.5rem;
  color: #f1f1f1;
  align-self: center;
  justify-self: center;
  padding: 5px 30px`
  ;

const InputBox = styled.input`
    height:34px;
    width: 100px;
    text-align: center;
    font-size: 26px;
    border:1px solid #ddd;
    border-radius:4px;
    display: inline-block;
    vertical-align: middle;
`;

export default Cart
